export enum AvailableServices {
    assurance = 'assurance',
    placements = 'placements',
    liquidites = 'liquidites',
    autres = 'autres',
    financementHypothecaire = 'financementHypothecaire',
}
